import './extensions/objectExtensions';
import './extensions/arrayExtensions';
import './extensions/stringExtensions';

const init = (() => {
  // PLACE ANY CODE HERE THAT NEEDS TO BE INITIALIZED PRIOR TO LOADING THE APP.
})();

export default init;
